import React from "react";
import { Card } from "react-bootstrap";
import { icons, Component } from "lucide-react";

export function ModuleCard({
  module,
  footer,
  hasBadge = false,
  showOnlyIcon = false,
}) {
  const typeColors = {
    teaching: "bg-blue-100 text-blue-700 border-blue-300",
    administration: "bg-yellow-100 text-yellow-700 border-yellow-300",
  };

  const IconComponent =
    module.icon && icons[module.icon] ? icons[module.icon] : Component;

  return (
    <Card className="category-card hover:shadow-lg transition-shadow cursor-pointer mb-4 p-3 rounded-2xl border flex-1">
      <Card.Body className="flex flex-col justify-between h-full">
        {/* 🔹 Title Row */}
        {showOnlyIcon ? (
          <div className="flex items-start gap-2 mb-3">
            <IconComponent className="title-icon h-6 w-6 mt-1 shrink-0" />

            <span className="text-lg font-bold break-words">{module.name}</span>
            {hasBadge && (
              <span
                className={`
              text-xs capitalize border px-2 py-0.5 rounded-full  ml-auto
              ${typeColors[module.type]}
            `}
              >
                {module.type}
              </span>
            )}
          </div>
        ) : (
          <div className="flex items-center gap-4">
            <div className="main-icon flex h-12 w-12 items-center justify-center rounded-xl shadow-md shrink-0">
              <IconComponent size={28} />
            </div>

            <div className="flex items-center justify-between flex-1">
              <span className="text-lg font-bold break-words">
                {module.name}
              </span>

              {hasBadge && (
                <span
                  className={`
                  text-xs capitalize border px-2 py-0.5 rounded-full
                  ${typeColors[module.type]}
                `}
                >
                  {module.type}
                </span>
              )}
            </div>
          </div>
        )}

        {/* 🔹 Description (aligned with title) */}
        <div
          className={
            !showOnlyIcon
              ? "pl-16" + " text-sm page-subtitle"
              : "mb-4 ms-4 " + "mt-2 text-xs page-subtitle line-clamp-2"
          }
          title={module.description}
        >
          {module.description}
        </div>

        {footer}
      </Card.Body>
    </Card>
  );
}
